import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Prescriptor } from '../models/prescriptor.model';
import { ApiResult } from './base.service';
import { LookupData } from '../models/lookup';
import { ApiResult as ApiResponse} from '../models/ApiResult';

@Injectable({
  providedIn: 'root'
})
export class PrescriptorService {

  constructor(protected http: HttpClient, @Inject('BASE_URL') protected baseUrl: string) { }

  getData(pageIndex: number, pageSize: number, sortColumn: string,
    sortOrder: string, filterColumn: string, filterQuery: string): Observable<ApiResult<Prescriptor>> {

    const url = this.baseUrl + 'api/Prescriptor';

    let params = new HttpParams()
      .set('pageIndex', pageIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('sortColumn', sortColumn)
      .set('sortOrder', sortOrder);

    if (filterQuery) {
      params = params
        .set('filterColumn', filterColumn)
        .set('filterQuery', filterQuery);
    }

    return this.http.get<ApiResult<Prescriptor>>(url, { params });
  }

  getPrescriptores(searchTerm: string) {
    let params = new HttpParams()
      .set('k', searchTerm);
    return this.http.get(`${this.baseUrl}api/Prescriptor/`, { params });
  }

  getCategoriasList() {
    return this.http.get(`${this.baseUrl}api/Prescriptor/Categorias`);
  }

  getPrescriptorById(id: number) {
    return this.http.get(`${this.baseUrl}api/Prescriptor/${id}`);
  }

  getPrescriptorLookup(searchTerm: string): Observable<LookupData> {
    return this.http.get<LookupData>(this.baseUrl + 'api/Prescriptor/Lookup?k=' + searchTerm);
  }

  getPrescriptorLookupId(id: number): Observable<LookupData> {
    return this.http.get<LookupData>(this.baseUrl + 'api/Prescriptor/Lookup/' + id.toString());
  }

  put(item): Observable<ApiResponse> {
    const url = `${this.baseUrl}api/Prescriptor/${item.id}`;
    console.log("put: " + url);
    return this.http.put<any>(url, item);
  }

  post(item): Observable<ApiResponse> {
    const url = `${this.baseUrl}api/Prescriptor`;
    console.log("post: " + url);
    return this.http.post<ApiResponse>(url, item);
  }

  delete(id: number) {
    const url = `${this.baseUrl}api/Prescriptor/${id}`;
    return this.http.delete<Prescriptor>(url);
  }
}
